import type { ChangelogEntry } from "../types";

/**
 * VIB-2796. Tidligere versjoner av et dokument tas nå vare på.
 * Ingen UI ennå (Erik 06.10.2026): oppsamlingen er poenget.
 */
export const DOKUMENTVERSJONER_2026_10: ChangelogEntry = {
  id: "2026-10-06-dokumentversjoner",
  date: "2026-10-06",
  title: "Tidligere versjoner av et dokument tas vare på",
  summary:
    "Når du lagrer et dokument, beholdes teksten slik den var før du endret den.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Versjonsnummeret har en tekst bak seg nå",
          kind: "nytt",
          body: "Arkivet har vist «v1», «v2» en stund, men den gamle teksten ble overskrevet. Nå tas den vare på, sammen med hvem som skrev den og hvem som endret den. For en HMS-rutine kan spørsmålet «hva sto her den datoen» komme lenge etterpå. Oppsamlingen startet i dag, så for det som er skrevet før dette finnes bare teksten slik den står nå.",
        },
        {
          title: "Du kan ikke lese gamle versjoner ennå",
          kind: "nytt",
          body: "De ligger lagret med samme tilgang som dokumentet selv, men det er ikke laget noen visning for dem. Det kommer, og det viktigste var å begynne å ta vare på dem.",
        },
      ],
    },
  ],
};
